var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7474 6.24731C23.3953 6.24731 22.0692 6.467 20.8125 6.89337C21.5149 7.41151 22.1631 7.98747 22.7514 8.61257C23.4039 8.48177 24.0717 8.41528 24.7474 8.41528C30.3082 8.41528 34.832 12.9391 34.832 18.5C34.832 24.0608 30.3082 28.5846 24.7474 28.5846C24.0717 28.5846 23.4039 28.5181 22.7514 28.3873C22.1631 29.0124 21.5149 29.5884 20.8125 30.1065C22.0692 30.5329 23.3953 30.7526 24.7474 30.7526C31.5035 30.7526 37 25.2561 37 18.5C37 11.7438 31.5035 6.24731 24.7474 6.24731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4569 19.5839H16.142C15.5429 19.5839 15.058 19.0983 15.058 18.5C15.058 17.9016 15.5429 17.416 16.142 17.416H24.4569C24.1338 13.7586 22.1855 10.4228 19.107 8.3423C17.0793 6.97214 14.7089 6.24731 12.2526 6.24731C5.49652 6.24731 0 11.7438 0 18.5C0 25.2561 5.49652 30.7526 12.2526 30.7526C14.7089 30.7526 17.0793 30.0278 19.107 28.6576C22.1855 26.5771 24.1338 23.2413 24.4569 19.5839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.457 19.5838H27.5182L27.1309 19.9705C26.7081 20.3939 26.7081 21.0805 27.1309 21.5039C27.3426 21.7157 27.6201 21.8212 27.8976 21.8212C28.1751 21.8212 28.4526 21.7157 28.6643 21.5039L30.9017 19.2666C30.932 19.2355 30.9609 19.203 30.9877 19.1683C31.1423 18.9783 31.2175 18.7391 31.2168 18.4999C31.216 18.2173 31.1091 17.9347 30.9017 17.7331L28.6643 15.4958C28.2409 15.073 27.5543 15.073 27.1309 15.4958C26.7081 15.9193 26.7081 16.6058 27.1309 17.0293L27.5182 17.4159H24.457C24.4896 17.7743 24.5055 18.1364 24.5055 18.4999C24.5055 18.8634 24.4896 19.2254 24.457 19.5838Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransition);
export default __webpack_public_path__ + "static/media/transition.6ca26034a09ec9bd5d289a69738e7a2e.svg";
export { ForwardRef as ReactComponent };